/** @format */

import React, { useEffect } from "react";
import { SingleBanner } from "../singleBanner/singleBanner";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

import { useState } from "react";
import {
  editApplicantDetail,
  getActiveJobVacancyList,
} from "../../adminDashboard/candidate/service/candidateServices";
import { toast } from "react-toastify";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ReCAPTCHA from "react-google-recaptcha";
import { captchaVerification } from "../../shared/captchaServices";
import { experienceCategoryList } from "../../adminDashboard/candidate/applicantData/constant";
import { CAPTCHA_SITE_KEY } from "../../Constants";
import { SpinnerLoader } from "../../shared/component/spinnerLoader";
import { green } from "@mui/material/colors";
import { CloudUploadOutlined } from "@mui/icons-material";
const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  experience: "",
  file: null,
  designation: "",
  captcha: "",
};

export default function ApplyNow() {
  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    experience: "",
    file: null,
    designation: "",
  });
  const [success, setSuccess] = React.useState(false);
  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      "&:hover": {
        bgcolor: green[700],
      },
    }),
  };
  const [formErrors, setFormErrors] = useState(initialValues);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [jobPositionsList, setJobPositionsList] = useState([]);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState({
    description: "",
    id: "",
    isActive: null,
    jobPosition: "",
    vacancy: null,
  });

  useEffect(() => {
    if (jobPositionsList.length) {
      setData({ ...data, ["designation"]: jobPositionsList[0].id });
      setSelectedRole(jobPositionsList[0]);
    }
  }, [jobPositionsList]);

  const handleRecaptchaChange = (value) => {
    captchaVerification({ captchaValue: value })
      .then((res) => {
        setFormErrors({ ...formErrors, captcha: "" });
        const { success } = res.data;
        setIsCaptchaValid(success);
        if (Boolean(success)) {
          // toast.success("Captcha Succesfully Verified");
        }
      })
      .catch((err) => {
        toast.error("Something Went wrong");
        setIsCaptchaValid(false);
      });
  };

  const isValidEmail = (email) => {
    const emailPattern =
      /^[a-zA-Z]+[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };
  const isValidPhone = (phone) => {
    const phonePattern = /^[0-9]{10}$/;
    return phonePattern.test(phone);
  };
  const isValidName = (name) => {
    const namePattern = /^[A-Za-z\s]*$/;
    return namePattern.test(name);
  };
  const handleContactForm = (e) => {
    e.preventDefault();

    const datainfo = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
      experience: data.experience,
      file: data.file,
      designation: data.designation,
    };
    const errors = {};

    if (datainfo.firstName.trim(" ") === "") {
      errors.firstName = "First Name is required";
    } else if (!isValidName(datainfo.firstName.trim(" "))) {
      errors.firstName = "Invalid format";
    }
    if (datainfo.lastName.trim(" ") === "") {
      errors.lastName = "Last Name is required";
    } else if (!isValidName(datainfo.lastName.trim(" "))) {
      errors.lastName = "Invalid format";
    }

    if (datainfo.phone === "") {
      errors.phone = "Phone Number is required";
    } else if (!isValidPhone(datainfo.phone)) {
      errors.phone = "Phone Number should be of 10 digit number only";
    }
    // if (datainfo.experience === "") {
    //   errors.experience = "Fill experience";
    // }

    if (datainfo.designation === "") {
      errors.designation = "Fill designation";
    }
    if (datainfo.file === null || datainfo.file === undefined) {
      errors.file = "Choose file";
    }

    if (datainfo.email === "") {
      errors.email = "Email is required";
    } else if (!isValidEmail(datainfo.email)) {
      errors.email = "Invalid Email Format";
    }
    if (!isCaptchaValid) {
      errors.captcha = "Please fill the Captcha first";
    }
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      if (!isCaptchaValid) {
        toast.error("Please fill the Captcha first");
      } else {
        const payload = {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          phoneNumber: data.phone,
          jobPositionId: data.designation,
          experience: data.experience,
        };
        let formData = new FormData();
        formData.append("resume", data.file);
        formData.append("studentData", JSON.stringify(payload));
        setIsLoading(true);
        editApplicantDetail(formData)
          .then((res) => {
            const { statusCode, message } = res.data;
            if (statusCode === 200) {
              toast.success("Application sent succcessfuly");
            } else {
              toast.error(message);
            }
            setIsLoading(false);
            setFormErrors(initialValues);
            setData({
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              experience: "",
              file: null,
              designation: "",
            });
            setSelectedFileName("");
          })
          .catch((err) => {
            const { message } = err.response.data;
            toast.error(message);
            setIsLoading(false);
          });
      }
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && value.length > 10) {
      return;
    } else if (
      (name === "firstName" || name === "lastName") &&
      value.length > 15
    ) {
      return;
    }
    if (name === "email" && value.length > 40) {
      return;
    }
    setData({ ...data, [name]: value });
    setFormErrors({
      ...formErrors,
      [name]: "",
    });
  };

  const handleFileChange = (e) => {
    setFormErrors({ ...formErrors, file: null });
    let selectedFile = e.target.files[0];
    setData({ ...data, file: selectedFile });
    setSelectedFileName(selectedFile?.name);
  };

  React.useEffect(() => {
    setIsLoading(true);
    getActiveJobVacancyList({ isActive: true })
      .then((res) => {
        const { methodResults } = res.data.records;
        setJobPositionsList(methodResults);
      })
      .catch((err) => {
        console.log("error::", err);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <Grid container>
      <Grid item xs={12} className="applynow">
        <SingleBanner title="Apply " titleorange={"Now"} />
      </Grid>
      <Grid item xs={12} className="d-flex flex-column justify-content-center">
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Typography variant="h4" className="linear-text-gradient">
              We're hiring
            </Typography>
          </Grid>

          <Grid
            item
            xs={10}
            md={9}
            lg={6}
            className="row_app rounded-5 p-20 "
            justifyContent="center"
            display="flex"
            sx={{
              boxShadow: "4px 5px 28px -6px #b4a7c9",
              marginBottom: "20px",
            }}
          >
            {jobPositionsList && jobPositionsList.length ? (
              <form>
                <Grid container>
                  {jobPositionsList?.map((role, index) => (
                    <Grid
                      item
                      className="category-suggestion-btn"
                      display={"flex"}
                    >
                      <Button
                        sx={{
                          textTransform: "none",
                          backgroundColor: `${
                            role.id === selectedRole.id ? "#35126c" : "white"
                          }`,
                          color: `${
                            role.id === selectedRole.id ? "white" : "black"
                          }`,
                        }}
                        className={`apply_now_tabs ${
                          role.id === selectedRole.id
                            ? "selected-apply-job-btn "
                            : "apply-job-btn "
                        }`}
                        variant="contained"
                        onClick={(e) => {
                          setData({ ...data, ["designation"]: role.id });
                          setSelectedRole(role);
                        }}
                      >
                        {role.jobPosition}
                      </Button>
                    </Grid>
                  ))}

                  <Grid
                    item
                    xl={12}
                    xs={12}
                    md={12}
                    sm={12}
                    sx={{
                      padding: "25px",
                      margin: "20px 0px 20px 0px",
                    }}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: selectedRole?.description,
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      type="text"
                      variant="outlined"
                      placeholder="First Name"
                      label="First Name"
                      name="firstName"
                      className="form-control-applynow"
                      value={data.firstName}
                      error={!!formErrors.firstName}
                      helperText={formErrors.firstName}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      type="text"
                      variant="outlined"
                      placeholder="Last Name"
                      className="last-name-input form-control-applynow"
                      label="Last Name"
                      name="lastName"
                      value={data.lastName}
                      error={!!formErrors.lastName}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      helperText={formErrors.lastName}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      type="email"
                      label="Email"
                      className=" form-control-applynow "
                      variant="outlined"
                      placeholder="Your Email"
                      name="email"
                      value={data.email}
                      error={!!formErrors.email}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      helperText={formErrors.email}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Phone Number"
                      type="number"
                      variant="outlined"
                      className=" form-control-applynow"
                      placeholder="Enter Phone Number"
                      name="phone"
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "+") e.preventDefault();
                      }}
                      value={data.phone}
                      error={!!formErrors.phone}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      helperText={formErrors.phone}
                    />
                  </Grid>

                  <Grid item xl={6} xs={6} md={6} sm={6}>
                    <FormControl
                      fullWidth
                      className="designation form-control-applynow"
                    >
                      <InputLabel
                        id="demo-simple-select-label"
                        className="role"
                      >
                        Designation
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        className="designation "
                        id="designation"
                        value={selectedRole.id}
                        label={"Job Position"}
                        name="designation"
                        onChange={(e) => {
                          setSelectedRole(
                            jobPositionsList.find((x) => x.id == e.target.value)
                          );

                          handleChange(e);
                        }}
                        error={formErrors.designation}
                        helperText={formErrors.designation}
                      >
                        {jobPositionsList?.map((role, index) => (
                          <MenuItem key={role.id} value={role.id}>
                            {role.jobPosition}
                          </MenuItem>
                        ))}
                      </Select>
                      {!!formErrors.designation && (
                        <div className="error-validation">
                          {" "}
                          {formErrors.designation}
                        </div>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xl={6} xs={6} md={6} sm={6}>
                    <FormControl
                      fullWidth
                      className="experience-year form-control-applynow"
                    >
                      <InputLabel id="demo-simple-select-label">
                        Experience(years)
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={data.experience || ""}
                        label={"Experience"}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        name="experience"
                        error={!!formErrors.experience}
                        helperText={formErrors.experience}
                      >
                        {experienceCategoryList.map((category) => (
                          <MenuItem key={category.id} value={category.value}>
                            {category.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {!!formErrors.experience && (
                        <div className="error-validation">
                          {formErrors.experience}
                        </div>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    className="d-flex justify-content-center border-dotted gap-3 align-items-center ms-3 mt-3"
                  >
                    <Grid item>
                      <Button component="label" className="filepdf pointer">
                        <CloudUploadOutlined className="ms-2" />
                        <input
                          type="file"
                          name="file"
                          accept=".pdf,.doc,.docx"
                          onChange={handleFileChange}
                          error={Boolean(formErrors.file)}
                          helperText={formErrors.file}
                          hidden
                        />
                        <span>{selectedFileName}</span>
                      </Button>
                    </Grid>
                    <Grid item>
                      <Typography variant="body2">
                        <span className="text-danger">*</span>Please select
                        .pdf/.doc/.docx upto 5 MB
                      </Typography>
                      {formErrors.file && (
                        <div className="error-validation">
                          {formErrors.file}
                        </div>
                      )}
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <ReCAPTCHA
                      sitekey={CAPTCHA_SITE_KEY}
                      onChange={handleRecaptchaChange}
                    />
                    {formErrors.captcha && (
                      <Typography className="error-validation">
                        {formErrors.captcha}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} textAlign={"center"}>
                    <Box>
                      <Button
                        className={"banner_btn pointer accordian-shadow py-2"}
                        variant="contained"
                        sx={buttonSx}
                        disabled={isLoading}
                        onClick={handleContactForm}
                      >
                        {isLoading ? (
                          <div>
                            Saving....
                            <CircularProgress
                              size={24}
                              sx={{
                                color: green[500],
                                marginTop: "-10px",
                              }}
                            />
                          </div>
                        ) : (
                          "Submit"
                        )}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            ) : (
              <Grid container display={"flex"} justifyContent={"center"}>
                <Typography variant="p" align="center">
                  Currently, we are receiving to many Applications. <br />
                  <img src="../../../media/workInProcess.jpg" width={400} />
                  <br />
                  We appreciate your interest and encourage you to check our
                  website for openings. <br />
                  We are only accepting applications between 9:00AM to 7:00 PM
                  IST time on working days.
                </Typography>
                {/* <img src="../../../media/no-vacancy.png" alt={"no-vacancy"} /> */}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
// "D:\project\codeji-internal\codeji-cms-React\public\media\no-vacancy.png";
